import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingDairyPrimaryData, setFootprintingDairyPrimaryDataAdmin } from "services";

import { footprintingDairyPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_AUTOFILL_APPLIED, FOOTPRINTING_DAIRY_PRIMARY_DATA } from "consts";

import { FootprintingDairyPrimaryData } from "models";

export interface CreateDairyPrimaryDataQueryParams {
  autofillYear?: number;
}

export const useMutateFootprintingDairyPrimaryData = (
  farmId: string,
  year: number,
  payload: Omit<FootprintingDairyPrimaryData, "id">,
  primaryDataId?: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  const setPrimaryData = isAdmin ? setFootprintingDairyPrimaryDataAdmin : setFootprintingDairyPrimaryData;
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_DAIRY_PRIMARY_DATA, primaryDataId, isAdmin],
      mutationFn: (qps?: CreateDairyPrimaryDataQueryParams) =>
        qps?.autofillYear ? setPrimaryData(payload, primaryDataId, qps) : setPrimaryData(payload, primaryDataId),
      onSuccess: async (_data, variables) => {
        if (variables?.autofillYear) {
          queryClient.setQueryData([FOOTPRINTING_AUTOFILL_APPLIED, "dairy", farmId, year], true);
        }
        invalidateAndRefecthQueries(queryClient, [...footprintingDairyPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin)]);
      },
    },
    queryClient
  );
};
